import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./productSlider.css";
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBContainer } from "mdbreact";
import Spinner from '../Spinner/Spinner.js';
import { detailReactCarouselControls } from '../../helpers/DetailReactCarouselControls.js';
import CrossBrowserImages from '../../scripts/CrossBrowserImages/CrossBrowserImages';
import _ from 'lodash';
import { screenshotProdList } from './screenshotProductArray';
import { $qsa } from '../../helpers/misc-javascript-helpers';


class ProductImageSlider extends Component {
    constructor(props) {
        super(props);
        this.carouselRef = React.createRef();
        this.state = {
            slidesLength: 0,
            isLoading: false,
            sliderImages: [],
            pristineImages: [],
            dataStack: [],
            desktopTracker: 0,
            mobileTracker: 0,
            tabletTracker: 0,
            loadedOnce: 0
        };
        this.cBrowserImages = new CrossBrowserImages();
        this.handleClickActions = this._handleClickActions.bind(this);
        this.runCrossBrowser = this._runCrossBrowser.bind(this);
        this.testingMode = false;
        this.screenshotProdList = screenshotProdList;
        if (this.cBrowserImages) {
            this.updateOncePerBreakPoint = this._updateOncePerBreakPoint.bind(this);
            window.addEventListener('resize', this.updateOncePerBreakPoint);
        }
    }

    componentDidMount() {
        const dataStack = this.props.sliderData.data.data.data;
        if (dataStack.hasOwnProperty('images')) {
            const slidesStack = dataStack.images;
            if (this.carouselRef.current) {
                this.carouselRef.current.setState({ length: slidesStack.length });
                this.carouselRef.current.setState({ initialLength: slidesStack.length });
                this.setState({ slidesLength: slidesStack.length });
                this.setState({ sliderImages: slidesStack });
                this.setState({ pristineImages: slidesStack });
                this.setState({ dataStack });
                this.runCrossBrowser(dataStack, slidesStack);
                if (!this.inTestingMode()) {
                    /* Set up enter keypress event handling */
                    this.handleClickActions();
                }
            }
        }
    }

    componentDidUpdate() {
        if (!this.inTestingMode() && this.state.loadedOnce === 0) {
            if (document.querySelectorAll('#product-image-slide-container a[data-test="carousel-control"]')) {
                const prevControl = document.querySelector('.carousel-control-prev');
                const nextControl = document.querySelector('.carousel-control-next');
                const controlButtons = [prevControl, nextControl];
                detailReactCarouselControls(controlButtons, 'i', 'fas fa-angle-right', 'fas fa-angle-left', true);
            }
            if ($qsa('.carousel-indicators li')) {
                const carouselIndicators = $qsa('.carousel-indicators li');
                carouselIndicators.forEach(element => {
                    element.classList.add('ci-item');
                    element.setAttribute('role', 'button');
                });
            }
            this.setState({ loadedOnce: 1 });
        }
    }

    /**
     * _handleClickActions - handles the enter key presses by triggering clicks for the event target.
     * @param {event} e 
     */
    _handleClickActions(event) {
        function simClick(event) {
            var pressedKey = event.which || event.keycode;
            if (pressedKey === 13) {
                this.click();
            }
        }
        const prevControl = document.querySelector('.carousel-control-prev');
        const nextControl = document.querySelector('.carousel-control-next');
        // Rig the previous button to trigger a click
        prevControl.addEventListener('keypress', simClick);
        // Rig the next button to trigger a click
        nextControl.addEventListener('keypress', simClick);
    }

    /** Executes the CrossBrowser Images code scheme. */
    _runCrossBrowser(data, images) {
        let msg = this.cBrowserImages.runCrossBrowser(this, data, images);
        return msg;
    }

    /** Ensures that the images update once per breaking point during onresize events. */
    _updateOncePerBreakPoint() {
        const curMedSt = this.cBrowserImages.detectBreakPoints();
        let currentBrkPoint = '';
        Object.keys(curMedSt).forEach(item => {
            if (curMedSt[item] === true) {
                currentBrkPoint = item;
            };
        });
        if (this.state[currentBrkPoint + 'Tracker'] < 1) {
            this.cBrowserImages.handleBrkPointCases(currentBrkPoint, 1);
            this.runCrossBrowser(this.state.dataStack, this.state.pristineImages);
        }
    }

    inTestingMode() {
        return typeof this.props.testingMode !== 'undefined' && this.props.testingMode;
    }

    render() {
        const show = { display: 'block', border: '2px solid #e6e6e6' };
        const hide = { display: 'none' };
        const style = this.state.slidesLength > 0 ? show : hide;
        const slidesTotal = this.state.sliderImages ? this.state.sliderImages.length : 3;
        return (
            <div style={style}>
                <Spinner isLoading={this.state.isLoading}></Spinner>
                <MDBContainer>
                    <MDBCarousel
                        activeItem={1}
                        length={slidesTotal}
                        showControls={true}
                        showIndicators={true}
                        className="z-depth-1"
                        interval={5000}
                        ref={this.carouselRef}
                    >
                        <MDBCarouselInner>
                            {(typeof (this.state.sliderImages) !== 'undefined') ? this.state.sliderImages.map((tdata, index) =>
                                <MDBCarouselItem itemId={index + 1} key={'mdb' + index}>

                                    <img src={tdata.image_file} alt={tdata.alt_text ? tdata.alt_text : 'Skye Learning Course Preview Icon ' + tdata.ordering} />

                                </MDBCarouselItem>
                            )
                                : ""}
                        </MDBCarouselInner>
                    </MDBCarousel>
                </MDBContainer>
            </div>
        );
    }
}

export default ProductImageSlider;